import React, { memo } from 'react';
import classNames from 'classnames/bind';
import styles from './InputRadio.module.scss';

const cx = classNames.bind(styles);

const InputRadio = (props) => {
	const { classArray = [], type, label, id, name, style = null, value = '', target, onChange = () => console.warn('onChange is not defined.'), disabled = false, labelSize = '16' } = props;

	return (
		<span
			className={cx('uiinput', classArray)}
			style={style}
		>
			<input
				type={type}
				id={id}
				name={name}
				value={value}
				checked={value === target}
				onChange={onChange}
				disabled={disabled}
			/>
			<label
				htmlFor={id}
				className={cx(`label_size${labelSize}`)}
			>
				<span className={cx('td')}>{label}</span>
			</label>
		</span>
	);
};

export default memo(InputRadio);
